import { HTTPError } from 'ky'

import type { Filter } from '@/types/Filters.ts'
import type { ExportRequest, Incident } from '@/types/Incident'
import type { Pagination } from '@/types/Pagination'
import { adaptFilter } from '@/utils/filters'

import ky from './httpService'

export const getIncidents = async ({
  limit = 20,
  offset = 0,
  sortBy = 'declared_timestamp',
  desc = true,
  search = '',
  includePerimeters = true,
  includeBadges = true,
  includeCalculations = false,
  includeBuffers = false,
  category = [],
  complexity = [],
  filters = [] as Filter[]
}): Promise<Pagination<Incident>> => {
  const URI = 'api/incident/getAll'
  const searchParams = new URLSearchParams()
  searchParams.append('limit', String(limit))
  searchParams.append('offset', String(offset))
  searchParams.append('sortBy', String(sortBy))
  searchParams.append('descendant', String(desc))
  searchParams.append('search', String(search))
  searchParams.append('includePerimeters', String(includePerimeters))
  searchParams.append('includeBuffers', String(includeBuffers))
  searchParams.append('includeBadges', String(includeBadges))
  searchParams.append('includeCalculations', String(includeCalculations))
  if (category.length) category.forEach((cat) => searchParams.append('category', cat))
  if (complexity.length) complexity.forEach((comp) => searchParams.append('complexity', comp))

  const adaptedFilters = filters.map(adaptFilter).filter((filter) => filter)

  const url = URI + '?' + searchParams.toString()

  const result: Pagination<Incident> = await ky
    .post(url, {
      body: JSON.stringify(adaptedFilters),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .json()
  return result
}

export const getIncident = async (idIncident: string): Promise<Incident | number> => {
  const URI = 'api/incident/' + idIncident
  let res = null
  try {
    res = await ky.get(URI)
    return res.json()
  } catch (error) {
    if (error instanceof HTTPError) {
      return error.response.status
    }
    throw error
  }
}

export const updateIncident = async (incident: Incident): Promise<Incident> => {
  const URI = `api/incident/${incident.id}`
  return await ky.patch(URI, { json: incident }).json()
}

export const saveIncident = async (incident: Incident) => {
  return ky.post('api/incident', { json: incident })
}

export const exportIncidents = async (data: ExportRequest) => {
  return ky.post('api/incident/export', { json: data })
}

class IncidentService {
  URI: string

  constructor() {
    this.URI = 'mocks/incidentes.geojson'
  }

  async getIncidents() {
    const response = await fetch(this.URI)
    return await response.json()
  }
}

export default IncidentService
